<template>
    <nav class="bg-cyan-600 border-b">
        <div class="max-w-8xl px-6 h-10 flex justify-between">
            <div class="flex justify-start items-center">
                <button type="button" class="md:hidden -ml-2 p-2 text-white" aria-label="Abrir menu" @click="$emit('toggleMobileMenu')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            </div>
            <div class="space-x-4 flex justify-end items-center">
                <!-- Trial countdown chip -->
                <router-link
                    v-if="showTrialChip"
                    :to="{ name: 'subscription' }"
                    class="hidden md:flex items-center gap-1.5 text-xs font-semibold bg-amber-400 text-amber-900 rounded-full px-3 py-1 hover:bg-amber-300 transition"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span v-if="daysLeft > 0">{{ daysLeft }}d de teste</span>
                    <span v-else>Teste encerrado</span>
                </router-link>
            </div>
        </div>
    </nav>
</template>

<script>
import AuthService from '../services/AuthService';
import { ref, computed } from 'vue';

export default {
    name: 'Navbar',
    emits: ['toggleMobileMenu'],
    setup() {
        const auth = ref(AuthService.getAuthInfo() || {});

        const daysLeft = computed(() => Number(auth.value.days_left) || 0);
        const showTrialChip = computed(() => {
            const status = auth.value.subscription_status;
            return status === 'trial' || status === 'expired_trial';
        });

        return { auth, daysLeft, showTrialChip };
    }
}
</script>
